import React from 'react';

const Admission = () => {
  return (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23.973" viewBox="0 0 22.72 23.973">
  <g id="Group_2474592" data-name="Group 2474592" transform="translate(713.563 -1629.571)">
    <path id="Subtraction_29" data-name="Subtraction 29" d="M18.59,20.394A5.131,5.131,0,0,1,13.62,14a.209.209,0,0,0,.119-.205V13.6a5.129,5.129,0,1,1,4.851,6.8ZM16.24,14.788a.191.191,0,0,0-.155.3l1.752,2.425a.191.191,0,0,0,.154.078.187.187,0,0,0,.153-.078l2.712-3.752a.189.189,0,0,0-.152-.3H19.652a.19.19,0,0,0-.154.078l-1.508,2.085-.548-.758a.191.191,0,0,0-.152-.078ZM13.023,18.53H1.842A.843.843,0,0,1,1,17.688V.842A.843.843,0,0,1,1.842,0h14.54a.843.843,0,0,1,.842.842V8.957a6.451,6.451,0,0,0-4.374,3.36H4.458c-.084,0-.153.094-.153.211v1.264c0,.116.069.211.153.211h7.805a6.452,6.452,0,0,0,.759,4.527ZM4.458,8.029c-.084,0-.153.094-.153.211V9.5c0,.116.069.211.153.211h9.129c.084,0,.153-.094.153-.211V8.24c0-.116-.069-.211-.153-.211Zm0-4.288c-.084,0-.153.094-.153.211V5.215c0,.116.069.211.153.211h9.129c.084,0,.153-.094.153-.211V3.951c0-.116-.069-.211-.153-.211Z" transform="translate(-714.563 1633.151)"/>
    <g id="Group_2474586" data-name="Group 2474586" transform="translate(-709.993 1629.073)">
      <path id="idcard" d="M72.658,161H64.321a.32.32,0,0,0-.321.321v1.053a.32.32,0,0,0,.321.321h8.338a.32.32,0,0,0,.321-.321v-1.053A.32.32,0,0,0,72.658,161Z" transform="translate(-64 -157.755)"/>
      <path id="Subtraction_34" data-name="Subtraction 34" d="M2.158,4.818A2.659,2.659,0,1,1,4.818,2.158,2.662,2.662,0,0,1,2.158,4.818Zm0-3.623a.964.964,0,1,0,.965.964A.965.965,0,0,0,2.158,1.194Z" transform="translate(2.144 1)"/>
    </g>
  </g>
</svg>

    </>
  )
};

export default Admission;
